/**
 * Company Routes
 *
 * Route definitions for the companies module.
 */

import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const CompanyDetailLayout = lazy(() => import('./CompanyDetailLayout'));
const CompanyDetailsLayout = lazy(() => import('./CompanyDetailsLayout'));
const CompanyDetailsInformationTab = lazy(() => import('./CompanyDetailsInformationTab'));
const CompanyDetailsNotesTab = lazy(() => import('./CompanyDetailsNotesTab'));
const CompanyBankAccountsPage = lazy(() => import('./CompanyBankAccountsPage'));
const CompanyAssetsPage = lazy(() => import('./CompanyAssetsPage'));
const CompanyDocumentsPage = lazy(() => import('./CompanyDocumentsPage'));
const CompanyInvoicesPage = lazy(() => import('./CompanyInvoicesPage'));
const CompanyOrgPage = lazy(() => import('./CompanyOrgPage'));
const ContractorCapacityPage = lazy(() => import('./ContractorCapacityPage'));
const ContractorPricingPage = lazy(() => import('./ContractorPricingPage'));

export const companyRoutes = [
    {
        path: 'companies/:companyId',
        element: <CompanyDetailLayout />,
        children: [
            { index: true, element: <Navigate to="details" replace /> },
            {
                path: 'details',
                element: <CompanyDetailsLayout />,
                children: [
                    { index: true, element: <Navigate to="information" replace /> },
                    { path: 'information', element: <CompanyDetailsInformationTab /> },
                    { path: 'notes', element: <CompanyDetailsNotesTab /> },
                ],
            },
            { path: 'bank-accounts', element: <CompanyBankAccountsPage /> },
            { path: 'assets', element: <CompanyAssetsPage /> },
            { path: 'documents', element: <CompanyDocumentsPage /> },
            { path: 'invoices', element: <CompanyInvoicesPage /> },
            { path: 'org', element: <CompanyOrgPage /> },
            { path: 'contractor-capacity', element: <ContractorCapacityPage /> },
            { path: 'contractor-pricing', element: <ContractorPricingPage /> },
        ],
    },
];
